import React, { memo } from "react";

const ModelImageList = ({ modelImages }) => (
  <div>
    { modelImages.map((item, index) => (
      <div className="adhesiveProduct" key={index+1}>
        <img
          src={item.imageUrl}
          alt={item.alt} />
        <div className="adhesiveProduct__name">{item.name}</div>
        <div className="adhesiveProduct__size">{item.productSize}</div>
      </div>
    ))}
  </div>
)

export default memo(ModelImageList)
